<header class="background-header classic-background"></header>
<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default'}">
    <section class="container admin-dashboard-parent resources-container">
        <section class="template-section-title">
			<div class="breadcrumb-container">
				<span>Admin <i class="fa fas fa-chevron-right"></i></span>
				<app-breadcrumb [pageName]="'Resources'" [isTopLevel]="true"></app-breadcrumb>
			</div>
			<div class="title-container">
                <h1>Resources</h1>
			</div>
		</section>

        <section class="template-body">
            <div class="notification-bubble-container">
                <app-notification-bubble></app-notification-bubble>
            </div>
            <app-loader *ngIf="itemIsNotSaved == true"></app-loader>
            <span class="label">Template Body:</span><br>
            <angular-editor [(ngModel)]="htmlContent" [config]="config" [(ngModel)]="item.content"></angular-editor>
            <input type="submit" value="Save" (click)="saveItem()">
        </section>
    </section>
</section>